import React, { useContext } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import logo from '~/assets/img/logo-repman.svg';
import { GlobalUiContext } from '~/context/globalUiContext';
import CtaClick from '~/components/ctaClick';
// import Search from './search';
import { getDocsUrl, getLoginUrl, getMarketingUrl, getRegisterUrl } from '~/helpers/url';

const Header = () => {
  const { hamburgerOpened, toggleHamburger } = useContext(GlobalUiContext);

  return (
    <header className="header-main">
      <Navbar expand="lg" variant="dark">
        <Container fluid>
          <button
            type="button"
            className={`toggler ${hamburgerOpened ? 'toggler--cross' : ''}`}
            onClick={toggleHamburger}
            aria-label="Toggle menu"
          >
            <span className="toggler__icon toggler--hamburger" />
          </button>
          <Navbar.Brand>
            <a href={getMarketingUrl()}>
              <img
                src={logo}
                className="brand__image"
                alt="Repman logo"
              />
            </a>
            <CtaClick cta={['docs-navigation-bar']}>
              <a href={getDocsUrl()} className="brand__text">
                Docs
              </a>
            </CtaClick>
          </Navbar.Brand>
          {/* <Search /> */}
          <div className="navbar-collapse__container">
            <Nav className="navbar-nav ml-auto" as="ul">
              <Nav.Item as="li">
                <a href={getLoginUrl()} className="nav-link">
                  Sign in
                </a>
              </Nav.Item>
              <Nav.Item as="li">
                <CtaClick cta={['sign-up-navigation-bar']}>
                  <a href={getRegisterUrl()} className="btn btn-primary">
                    Sign up
                  </a>
                </CtaClick>
              </Nav.Item>
            </Nav>
          </div>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
